import { render, staticRenderFns } from "./EmployeeForm.vue?vue&type=template&id=86134726&scoped=true&"
import script from "./EmployeeForm.js?vue&type=script&lang=js&"
export * from "./EmployeeForm.js?vue&type=script&lang=js&"
import style0 from "./EmployeeForm.scss?vue&type=style&index=0&id=86134726&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86134726",
  null
  
)

export default component.exports